/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function () {
    if ($(window).width() > 999) {
        $(document).on('click', '.header__cart-icon-main', function (event) {
            event.preventDefault();
            $(".header__action-item--cart .header__cart-icon").click();
            $(".overlay").addClass('active');
            $("body").addClass('no-scroll');

        });

        $(".overlay").click(function () {
            $(this).removeClass('active');
            $(".mini-cart").attr('aria-hidden', 'true');
            $("body").removeClass('no-scroll');
        });

        $(document).on('click', '.cart__close', function (event) {
            $(".overlay").removeClass('active');
            $(".mini-cart").attr('aria-hidden', 'true');
            $("body").removeClass('no-scroll');
        });

        $(document).on('click', '.product-form__payment-container', function (event) {
            $(".overlay").addClass('active');
            $("body").addClass('no-scroll');
        });

        document.addEventListener('product:added', function (event) {
            $(".overlay").addClass('active');
            $("body").addClass('no-scroll');
        });

    }
    if ($(window).width() < 999) {
        $('.product-form__add-button').on('click', function (e) {
            setTimeout(function () {
                $(location).prop('href', '/cart');
            }, 1000);

        })
    }

});

//


